import React from "react";
import { useHistory } from "react-router";
import { Button, Row } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { TypesCharacteristicsListSearch } from "../../features/TypesCharacteristicsListSearch/TypesCharacteristicsListSearch";
import { TypesCharacteristicsListTable } from "../../features/TypesCharacteristicsListTable/TypesCharacteristicsListTable";
import { hasAccess } from "../../../../components/RolesModule/hasAccess";
import { MENU_ADMIN_CHAR_TYPE_WRITE } from "../../../../lib/const/permissions";
import "./TypesCharacteristicsList.less";

export const TypesCharacteristicsList = () => {
  const history = useHistory();

  return (
    <div className="types-characteristics-list">
      <Row justify="space-between">
        <h1>Типы характеристик</h1>

        {hasAccess(MENU_ADMIN_CHAR_TYPE_WRITE) && (
          <Button
            icon={<PlusOutlined />}
            type="primary"
            className="types-characteristics-list__add-btn"
            onClick={() => {
              history.push(`/types-characteristics/create`);
            }}
          >
            Создать тип
          </Button>
        )}
      </Row>
      <TypesCharacteristicsListSearch />
      <TypesCharacteristicsListTable />
    </div>
  );
};
